import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2ab15450"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "potato_content_box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "potato_setting"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "potato_icon",
  src: "https://p6.moimg.net/mdwxapp/potato_icon.png"
}), /*#__PURE__*/_createElementVNode("p", null, "小红书种草活动")], -1));
const _hoisted_3 = {
  class: "potato_column"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "patato_title"
}, "活动时间", -1));
const _hoisted_5 = {
  class: "patato_txt potato_time"
};
const _hoisted_6 = {
  class: "potato_column"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "patato_title"
}, "活动奖品", -1));
const _hoisted_8 = {
  class: "patato_txt potato_title"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "potato_column"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "patato_title"
}, "活动参与要求", -1));
const _hoisted_12 = {
  class: "patato_txt patato_describe",
  ref: "describe"
};
const _hoisted_13 = {
  class: "potato_column"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "patato_title"
}, "奖品发放时间", -1));
const _hoisted_15 = {
  class: "patato_txt distribute_time_type"
};
const _hoisted_16 = {
  class: "potato_column"
};
const _hoisted_17 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($data.potatoObj.start_time || '同更新发布时间') + " — " + _toDisplayString($data.potatoObj.end_time), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString($data.potatoObj.prize_title), 1), _createElementVNode("img", {
    class: "patato_cover",
    src: $options.imgUrlFilter($data.potatoObj.prize_img, 690 * $data.radio)
  }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, null, 512)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, _toDisplayString($data.potatoObj.distribute_time), 1)]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.potatoObj.btn_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(['btn', {
        'active': item.btn_type == 1 || item.btn_type == 4
      }, {
        'disabled': item.btn_type == 2
      }]),
      onClick: _withModifiers($event => $options.potatoBtnClick(item.btn_type), ["stop"])
    }, _toDisplayString(item.btn_name), 11, _hoisted_17);
  }), 128))])]);
}